import { init, captureException } from '@sentry/browser';

// エラー通知が必要な箇所でこのファイルを import する。
// initSentry で初期化、captureException でエラーを通知

const initSentry = () => {
  init({
    dsn: 'https://63314967ddd40bbb40bcda5550c0f4be@o4506572598149120.ingest.sentry.io/4506698316447744',
    defaultIntegrations: false,
  });
};

export { initSentry, captureException };
